import { APP_MOBILE_LAYOUT, APP_COLOR_PALETTE } from '@/store/modules/app';


export default {
  namespaced: true,
  state: {
    currentStepIndexFlow1: 1,
    optionSecondStepSelectedFlow1: APP_COLOR_PALETTE.GREEN_RED,
    optionThirdStepSelectedFlow1: APP_MOBILE_LAYOUT.CONDENSED,
  },
  mutations: {
    nextStepFlow1(state) {
      state.currentStepIndexFlow1 += 1;
    },
    prevStepFlow1(state) {
      state.currentStepIndexFlow1 -= 1;
    },
    selectOptionThirdStepFlow1(state, value) {
      state.optionThirdStepSelectedFlow1 = value;
    },
    selectOptionSecondStepFlow1(state, value) {
      state.optionSecondStepSelectedFlow1 = value;
    },
  },
  actions: {
    nextStepFlow1({ commit }) {
      commit('nextStepFlow1');
    },
    prevStepFlow1({ commit }) {
      commit('prevStepFlow1');
    },
    selectOptionSecondStepFlow1({ commit }, value) {
      commit('selectOptionSecondStepFlow1', value);
    },
    selectOptionThirdStepFlow1({ commit }, value) {
      commit('selectOptionThirdStepFlow1', value);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/whatisnew.js